import { createRef, useEffect, useLayoutEffect, useRef, useState } from "react";
import { InputCounter } from "views/guest/common/InputCounter";
import { getRef } from "views/utils/InputHelp";
import { addCart } from "views/utils/CartFunc";
import * as CommonConst from "views/utils/CommonConst";
import { useHistory } from "react-router-dom";
import { getApiData } from "views/utils/CallApi";
import { AxiosResponse } from "axios";
import { numberToPrice } from "views/utils/CommonFunc";
import { MultiLine } from "views/common/MultiLine";
import { Error } from "views/guest/pages/error/Error";
import { sendWindowHeight } from "views/utils/CommonFunc"

export function Service(): JSX.Element{

    const [services, setServices] = useState<CommonConst.IFService[]>([]);
    const history = useHistory();
    const [loadErr, setLoadErr] = useState("");
    const refWindow = useRef<HTMLDivElement>(null);

    useEffect(function(){

        let apiRes:any = [];

        getApiData('/cart/products',
            {},
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        apiRes = res.data.product_list;
                        let tmpServicies:CommonConst.IFService[] = [];
                        apiRes.forEach(function(service:any){
                            //オプション保持
                            let tmpOptions:any[] = [];
                            service.option_list.forEach(function(option:any){
                                tmpOptions.push({
                                    option_id: option.option_id,
                                    option_name: option.option_name,
                                    option_explanation: option.option_explanation,
                                    option_price: numberToPrice(Number(option.option_price)),
                                    option_image: option.option_image,
                                    option_count: 0,
                                    option_counter: createRef(),
                                });
                            });
                            //サービス保持
                            tmpServicies.push({
                                service_id: service.service_id,
                                service_name: service.service_name,
                                service_price: numberToPrice(Number(service.service_price)),
                                service_image: service.service_image,
                                service_explanation: service.service_explanation,
                                service_url: service.service_url,
                                service_unit: service.service_unit,
                                service_count: 0,
                                service_counter: createRef(),
                                option_list: tmpOptions,
                            });
                        });
                        setServices(tmpServicies);

                        //ウィンドウサイズを呼び出し元に渡す
                        sendWindowHeight(refWindow);
                        
                        break;
                    default:
                        setLoadErr("api_error");
                }
            }
        );

    }, []);

    //画面リサイズでウィンドウサイズを呼び出し元に渡す
    useLayoutEffect(function(){
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    });
    function resize(){
        sendWindowHeight(refWindow);
    }

    function clickSubmitCart(){

        let tmpServicies:CommonConst.IFCart[] = [];
        services.forEach(function(service){

            let tmpOptions:any = [];
            if (Number(getRef(service.service_counter)) > 0){
                service.option_list.forEach(function(option){
                    if (Number(getRef(option.option_counter)) > 0){
                        tmpOptions.push({
                            option_id: option.option_id,
                            option_name: option.option_name,
                            option_explanation: option.option_explanation,
                            option_price: option.option_price,
                            option_image: option.option_image,
                            option_count: Number(getRef(option.option_counter)),
                        });
                    }
                });
                tmpServicies.push({
                    service_id: service.service_id,
                    service_name: service.service_name,
                    service_price: service.service_price,
                    service_image: service.service_image,
                    service_explanation: service.service_explanation,
                    service_url: service.service_url,
                    service_unit: service.service_unit,
                    service_count: Number(getRef(service.service_counter)),
                    option_list: tmpOptions,
                })
            }

        });

        if (tmpServicies.length != 0){
            addCart(tmpServicies);
        }
        history.push("/guest/cart");

    }

    //カウンターを制御するための処理
    function changeCounter(serviceIdx:number, optionIdx?:number){
        let tmpServices:CommonConst.IFService[] = services.concat();
        if (optionIdx === undefined){
            tmpServices[serviceIdx].service_count = Number(getRef(services[serviceIdx].service_counter));
            tmpServices[serviceIdx].option_list.forEach(function(option){
                if (tmpServices[serviceIdx].service_count === 0){
                    option.option_count = 0;
                } else {
                    option.option_count = Number(getRef(option.option_counter));
                }
            });
        } else {
            tmpServices[serviceIdx].option_list[optionIdx].option_count = Number(getRef(services[serviceIdx].option_list[optionIdx].option_counter));
        }
        setServices(tmpServices);
    }

    if (loadErr){
        return (
            <Error type={loadErr}/>
        )
    } else {
        return (
            <div className="order-main" ref={refWindow}>
                <div className="order-howto">
                    <div>下記サービスより、ご利用予定の数を指定して、ボタンを押してください</div>
                    <span className="icon material-icons-round pc-parts">navigate_next</span>
                    <button className="btn-order btn-primary btn-icon-left btn-into-cart" onClick={clickSubmitCart}><span className="icon material-icons-round md-24">add_shopping_cart</span>この条件で見積カートに入れる</button>
                </div>
                {services.map(function(sv_item, sv_idx){
                    return (
                        <div key={sv_idx} className="order-item">
                            <div className="order-item-title order-item-title-service">{sv_item.service_name}</div>
                            <div className="order-item-service">
                                {sv_item.service_image && 
                                <div className="order-item-img-service"><img src={sv_item.service_image} alt={sv_item.service_name}/></div>
                                }
                                <div className={sv_item.service_image ? "order-item-main-service" : "order-item-main-service no-img"}>
                                    <div className="order-item-desc">
                                        <MultiLine val={sv_item.service_explanation}/>
                                    </div>
                                    <div className="order-item-footer">
                                        <div className="order-item-price">
                                            価格：<span className="text-color-orange text-size-l text-weight-bold">{sv_item.service_price}</span>(税込)
                                        </div>
                                        <div className="order-item-control-wrap">
                                            <div className="order-item-control order-item-control-service">
                                                <InputCounter unit={sv_item.service_unit} counterRef={sv_item.service_counter} changeEvent={changeCounter}
                                                    serviceIdx={sv_idx}></InputCounter>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(sv_item.option_list.length > 0) &&
                                <div className="order-item-option">
                                    <div className="order-item-header-option"><span className="material-icons-round">expand_more</span>オプション</div>
                                    <ul className="order-item-option-list">
                                        {sv_item.option_list.map(function(op_item, op_idx){
                                            return (
                                                <li key={op_idx}>
                                                    {op_item.option_image &&
                                                    <div className="order-item-img-option"><img src={op_item.option_image} alt={op_item.option_name}/></div>
                                                    }
                                                    <div className={op_item.option_image ? "order-item-main-option" : "order-item-main-option no-img"}>
                                                        <div className="order-item-title order-item-title-option">{op_item.option_name}</div>
                                                        <div className="order-item-desc order-item-desc-option">
                                                            <MultiLine val={op_item.option_explanation}/>
                                                        </div>
                                                        <div className="order-item-footer">
                                                            <div className="order-item-price order-item-price-option">
                                                                価格：<span className="text-color-orange text-size-l text-weight-bold">{op_item.option_price}</span>(税込)
                                                            </div>
                                                            <div className="order-item-control-wrap order-item-control-wrap-option">
                                                                <div className="order-item-control">
                                                                    <InputCounter counterRef={op_item.option_counter} changeEvent={changeCounter} 
                                                                        parentCounterRef={sv_item.service_counter}
                                                                        serviceIdx={sv_idx} optionIdx={op_idx}></InputCounter>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            }
                            <div className="order-item-cart">
                                <div>数を指定して、ボタンを押してください</div>
                                <span className="icon material-icons-round pc-parts">navigate_next</span>
                                <button className="btn-order btn-primary btn-icon-left btn-into-cart" onClick={clickSubmitCart}><span className="icon material-icons-round md-24">add_shopping_cart</span>この条件で見積カートに入れる</button>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}